import * as React from 'react';
const SvgReportsEmpty = (props) => (
  <svg
    width={191}
    height={140}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_7377_64663)">
      <path
        d="M86.7596 116.477C114.759 116.477 137.459 93.777 137.459 65.677C137.459 37.577 114.759 14.877 86.7596 14.877C58.7596 14.877 36.0596 37.577 36.0596 65.677C36.0596 93.777 58.7596 116.477 86.7596 116.477Z"
        fill="#EAEEF9"
      />
      <g filter="url(#filter0_d_7377_64663)">
        <path
          d="M97.0466 46.0656C97.0466 53.505 91.0304 59.5212 83.5264 59.5212C83.397 59.5212 82.2973 59.5212 74.211 59.5212C68.583 59.5212 59.5911 59.5212 45.2299 59.5212H38.3727C29.3808 59.7152 22.2002 52.5346 22.2002 43.8662C22.2002 35.133 29.4455 27.8877 38.5668 28.3406C46.3943 3.8877 82.2326 7.31627 85.273 32.6101C92.0008 33.4511 97.0466 39.1438 97.0466 46.0656Z"
          fill="url(#paint0_linear_7377_64663)"
        />
      </g>
      <path
        d="M83.5262 59.5215C90.9655 59.5215 97.0464 53.5053 97.0464 46.066C97.0464 38.6266 90.9655 32.6104 83.5262 32.6104C76.0868 32.6104 70.0059 38.6266 70.0059 46.066C70.0059 53.5053 76.0868 59.5215 83.5262 59.5215Z"
        fill="url(#paint1_linear_7377_64663)"
      />
      <path
        d="M61.467 59.6504C74.7284 59.6504 85.5317 48.9118 85.5317 35.6504C85.5317 22.3889 74.7284 11.6504 61.467 11.6504C48.2055 11.6504 37.4023 22.3889 37.4023 35.6504C37.4023 48.9118 48.1408 59.6504 61.467 59.6504Z"
        fill="url(#paint2_linear_7377_64663)"
      />
      <g filter="url(#filter1_d_7377_64663)">
        <path
          d="M168.606 81.2009C168.606 89.3714 161.999 95.9788 153.757 95.9788C153.615 95.9788 152.407 95.9788 143.526 95.9788C137.345 95.9788 127.47 95.9788 111.697 95.9788H104.166C94.2905 96.192 86.4043 88.3056 86.4043 78.7852C86.4043 69.1938 94.3616 61.2365 104.379 61.7338C112.976 34.8778 152.336 38.6433 155.675 66.4229C163.064 67.3465 168.606 73.5988 168.606 81.2009Z"
          fill="url(#paint3_linear_7377_64663)"
        />
      </g>
      <path
        d="M153.757 95.9796C161.928 95.9796 168.606 89.3721 168.606 81.2017C168.606 73.0312 161.928 66.4238 153.757 66.4238C145.587 66.4238 138.908 73.0312 138.908 81.2017C138.908 89.3721 145.587 95.9796 153.757 95.9796Z"
        fill="url(#paint4_linear_7377_64663)"
      />
      <path
        d="M129.53 96.1216C144.095 96.1216 155.96 84.3277 155.96 69.7629C155.96 55.1982 144.095 43.4043 129.53 43.4043C114.965 43.4043 103.1 55.1982 103.1 69.7629C103.1 84.3277 114.894 96.1216 129.53 96.1216Z"
        fill="url(#paint5_linear_7377_64663)"
      />
      <g filter="url(#filter2_d_7377_64663)">
        <path
          d="M85.5319 97.8547C85.5319 102.504 81.7718 106.265 77.0818 106.265C77.0009 106.265 76.3136 106.265 71.2597 106.265C67.7421 106.265 62.1222 106.265 53.1465 106.265H48.8607C43.2408 106.386 38.7529 101.898 38.7529 96.48C38.7529 91.0218 43.2812 86.4935 48.982 86.7765C53.8742 71.4935 76.2731 73.6364 78.1734 89.445C82.3783 89.9706 85.5319 93.5286 85.5319 97.8547Z"
          fill="url(#paint6_linear_7377_64663)"
        />
      </g>
      <path
        d="M77.0819 106.265C81.7315 106.265 85.5321 102.504 85.5321 97.855C85.5321 93.2054 81.7315 89.4453 77.0819 89.4453C72.4323 89.4453 68.6318 93.2054 68.6318 97.855C68.6318 102.504 72.4323 106.265 77.0819 106.265Z"
        fill="url(#paint7_linear_7377_64663)"
      />
      <path
        d="M63.2953 106.345C71.5837 106.345 78.3358 99.6341 78.3358 91.3457C78.3358 83.0572 71.5837 76.3457 63.2953 76.3457C55.0069 76.3457 48.2549 83.0572 48.2549 91.3457C48.2549 99.6341 54.9665 106.345 63.2953 106.345Z"
        fill="url(#paint8_linear_7377_64663)"
      />
      <path
        d="M83.1172 46.6161L76.5223 51.9317C75.2926 52.8488 73.6869 52.1952 73.3109 50.6243L71.1094 35.373"
        fill="#A5B0BE"
      />
      <path
        d="M146.145 8.06934L141.907 11.9902L97.5604 53.3317C95.5397 55.2687 92.4144 55.1864 90.3309 53.4014L74.3988 38.738L71.2029 35.766L62.3909 27.4949C60.5032 25.6631 61.3646 22.3428 63.9572 21.9298L136.847 9.87964L146.145 8.06934Z"
        fill="#CBD4E0"
      />
      <path
        d="M146.145 8.06934L141.908 11.9902L74.548 38.4947L71.1562 35.5697L136.996 9.63641L146.145 8.06934Z"
        fill="#A5B0BE"
      />
      <path
        d="M23.3521 91.3299L20.5279 93.7341C20.0004 94.1501 19.2899 93.8828 19.1068 93.1996L17.9639 86.5498"
        fill="#A5B0BE"
      />
      <path
        d="M50.4874 73.7158L48.6787 75.4818L29.7533 94.0988C28.8916 94.9704 27.5226 94.9711 26.5897 94.2143L19.4436 87.9832L18.0098 86.7199L14.0554 83.2031C13.2076 82.4235 13.5457 80.96 14.6756 80.7487L46.4391 74.6174L50.4874 73.7158Z"
        fill="#CBD4E0"
      />
      <path
        d="M50.4878 73.7168L48.6791 75.4828L19.5063 87.876L17.9873 86.6355L46.5018 74.5102L50.4878 73.7168Z"
        fill="#A5B0BE"
      />
      <path
        d="M78.3756 101.833L73.2044 106.235C72.2386 106.997 70.9376 106.507 70.6025 105.256L68.5098 93.0801"
        fill="#A5B0BE"
      />
      <path
        d="M128.06 69.582L124.749 72.8156L90.0961 106.904C88.5182 108.5 86.0117 108.501 84.3034 107.116L71.2188 95.7059L68.5935 93.3927L61.353 86.9535C59.8007 85.526 60.4196 82.8463 62.4886 82.4595L120.648 71.233L128.06 69.582Z"
        fill="#CBD4E0"
      />
      <path
        d="M128.061 69.582L124.749 72.8156L71.3331 95.5077L68.5518 93.2364L120.762 71.0349L128.061 69.582Z"
        fill="#A5B0BE"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_7377_64663"
        x={0.200195}
        y={0.708984}
        width={118.847}
        height={91.8164}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={11} />
        <feGaussianBlur stdDeviation={11} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7377_64663"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_7377_64663"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_7377_64663"
        x={64.4043}
        y={32.4678}
        width={126.202}
        height={96.5156}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={11} />
        <feGaussianBlur stdDeviation={11} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7377_64663"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_7377_64663"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_7377_64663"
        x={16.7529}
        y={65.3818}
        width={90.7793}
        height={73.8857}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={11} />
        <feGaussianBlur stdDeviation={11} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7377_64663"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_7377_64663"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_7377_64663"
        x1={59.6234}
        y1={31.4684}
        x2={59.599}
        y2={60.0405}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={0.9964} stopColor="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_7377_64663"
        x1={68.5672}
        y1={29.7135}
        x2={80.5528}
        y2={42.822}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BCCBE1" />
        <stop offset={0.9942} stopColor="white" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="paint2_linear_7377_64663"
        x1={35.1489}
        y1={24.6374}
        x2={54.0392}
        y2={32.0297}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E2E8F0" />
        <stop offset={0.9942} stopColor="white" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="paint3_linear_7377_64663"
        x1={127.505}
        y1={65.1691}
        x2={127.478}
        y2={96.5492}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={0.9964} stopColor="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_7377_64663"
        x1={137.328}
        y1={63.2421}
        x2={150.492}
        y2={77.639}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BCCBE1" />
        <stop offset={0.9942} stopColor="white" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="paint5_linear_7377_64663"
        x1={100.625}
        y1={57.6677}
        x2={121.372}
        y2={65.7865}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E2E8F0" />
        <stop offset={0.9942} stopColor="white" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="paint6_linear_7377_64663"
        x1={62.1424}
        y1={88.7315}
        x2={62.1272}
        y2={106.589}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={0.9964} stopColor="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_7377_64663"
        x1={67.7326}
        y1={87.6347}
        x2={75.2235}
        y2={95.8276}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BCCBE1" />
        <stop offset={0.9942} stopColor="white" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="paint8_linear_7377_64663"
        x1={46.8465}
        y1={84.4626}
        x2={58.6529}
        y2={89.0828}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E2E8F0" />
        <stop offset={0.9942} stopColor="white" stopOpacity={0} />
      </linearGradient>
      <clipPath id="clip0_7377_64663">
        <rect
          width={191}
          height={139}
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgReportsEmpty;
